<template>

  <div class="animated fadeIn card" v-show="show">

    <b-modal v-model="confirmRemovePage"
      title="Remover Página"
      class="modal-primary"
      @ok="removeSEOPage">

      Deseja remover o SEO da página?

    </b-modal>

    <div class="tab">
      <button class="tablinks tab-email" v-on:click="open($event, 'email')" id="defaultOpen">Endereços de e-mail</button>
      <button class="tablinks tab-seo" v-on:click="open($event, 'seo')">SEO</button>
      <button class="tablinks tab-workWithUs" v-on:click="open($event, 'workWithUs')">Links e Informações</button>
      <button class="tablinks tab-privacyAndCookies" v-on:click="open($event, 'privacyAndCookies')">Privacidade e Cookies</button>
    </div>

    <div class="card-body w-100">
      <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
        <div class="card-box">
          <div id="email" class="tabcontent">
            <h3>
              Endereços de e-mail
            </h3>

            <b-alert show dismissible variant="info">
              Informe os emails separados por ";". Caso nenhum e-mail seja informado, todos os usuários administradores receberão os e-mails.
            </b-alert>

            <div class="row mt-4">
              <!-- <b-form-group
                id="group"
                class="col-6"
                label="Responsável Contato"
                label-for="contact_receivers"
                description="E-mail que receberá os contatos enviados no formulário de fale conosco">
                <b-form-input id="contact_receivers"
                  type="text"
                  v-model="form.contact_receivers"
                  placeholder=""
                  :class="{
                    'is-invalid': submitted && form.errors.has('contact_receivers')
                  }">
                </b-form-input>
              </b-form-group> -->

              <b-form-group
                id="group"
                class="col-6"
                label="Responsável Formulário 'Orçamento'"
                label-for="contact_receivers_budget"
                description="E-mail que receberá os contatos de interesse pelos produtos">
                <b-form-input id="contact_receivers_budget"
                  type="text"
                  v-model="form.contact_receivers_budget"
                  placeholder=""
                  :class="{
                    'is-invalid': submitted && form.errors.has('contact_receivers_budget')
                  }">
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="group"
                class="col-6"
                label="Responsável Formulário da Campanha de divulgação"
                label-for="contact_receivers_campaign"
                description="E-mail que receberá os contatos de interesse pela campanha">
                <b-form-input id="contact_receivers_campaign"
                  type="text"
                  v-model="form.contact_receivers_campaign"
                  placeholder=""
                  :class="{
                    'is-invalid': submitted && form.errors.has('contact_receivers_campaign')
                  }">
                </b-form-input>
              </b-form-group>
            </div>
          </div>

          <div id="seo" class="tabcontent">
            <h3 class="mb-4">
              SEO das páginas estáticas
              <button type="button" class="float-right btn btn-primary" v-on:click="newSEOPage()">
                <i class="icon-plus"></i>
                &nbsp;&nbsp;
                Adicionar página
                </button>
            </h3>

            <div class="row mb-3" v-if="form.seo_pages.length > 0">
              <div class="col-lg-4" v-for="(page, index) in form.seo_pages">
                <b-card>
                  <h4 class="card-title">
                    Detalhes da página
                    <button type="button" class="float-right btn btn-link btn-sm text-danger pr-0" v-on:click="openRemovePageModal(index)">Remover página</button>
                  </h4>
                  <b-form-group id="group"
                      class="col-12 no-padding"
                      label="URL de refêrencia"
                      :label-for="'seo-url-' + index">

                      <b-form-input :id="'seo-url-' + index"
                        type="text"
                        placeholder="ex: /institucional"
                        required
                        v-model="page.url">
                      </b-form-input>
                    </b-form-group>

                    <b-form-group id="group"
                        class="col-12 no-padding"
                        label="Título da página"
                        :label-for="'seo-title-' + index">

                        <b-form-input :id="'seo-title-' + index"
                          type="text"
                          placeholder="Título da página"
                          required
                          maxlength="70"
                          v-model="page.title">
                        </b-form-input>
                        <span class="text-muted caracteres-counter float-right">{{ page.title.length }}/70 caracteres</span>

                    </b-form-group>

                    <b-form-group id="group"
                        class="col-12 no-padding"
                        label="Descrição da página"
                        :label-for="'seo-description-' + index">

                        <b-form-textarea
                          :id="'seo-description-' + index"
                          placeholder="Descrição da página"
                          required
                          maxlength="160"
                          :rows="3"
                          v-model="page.description">
                        </b-form-textarea>
                        <span class="text-muted caracteres-counter float-right">{{ page.description.length }}/160 caracteres</span>
                    </b-form-group>
                  </b-card>
              </div>
            </div>
            <div class="row mb-5" v-if="form.seo_pages.length == 0">
              <div class="col-lg-12">
                Não há páginas cadastradas.
              </div>
            </div>
          </div>

          <div id="workWithUs" class="tabcontent">
            <h3 class="mt-4 mb-4">
              Redes Sociais
            </h3>
            <div class="row">
              <b-form-group
                id="group"
                class="col-6"
                label="Twitter (Redes Sociais)"
                label-for="social-twitter"
                description="Caso não tenha deixar em branco">
                  <b-form-input
                    id="social-twitter"
                    type="url"
                    v-model="form.social_twitter"
                    placeholder="https://twitter.com/user">
                  </b-form-input>
              </b-form-group>
              <b-form-group
                id="group"
                class="col-6"
                label="Youtube (Redes Sociais)"
                label-for="social-youtube"
                description="Caso não tenha deixar em branco">
                  <b-form-input
                    id="social-youtube"
                    type="url"
                    v-model="form.social_youtube"
                    placeholder="https://www.youtube.com/channel/user">
                  </b-form-input>
              </b-form-group>
            </div>
            <div class="row">
              <b-form-group
                id="group"
                class="col-6"
                label="Facebook (Redes Sociais)"
                label-for="social-facebook"
                description="Caso não tenha deixar em branco">
                  <b-form-input
                    id="social-facebook"
                    type="url"
                    v-model="form.social_facebook"
                    placeholder="https://www.facebook.com/user">
                  </b-form-input>
              </b-form-group>
              <b-form-group
                id="group"
                class="col-6"
                label="Linkedin (Redes Sociais)"
                label-for="social-linkedin"
                description="Caso não tenha deixar em branco">
                  <b-form-input
                    id="social-linkedin"
                    type="url"
                    v-model="form.social_linkedin"
                    placeholder="https://www.linkedin.com/user/?originalSubdomain=pt">
                  </b-form-input>
              </b-form-group>
              <b-form-group
                id="group"
                class="col-6"
                label="Instagram (Redes Sociais)"
                label-for="social-instagram"
                description="Caso não tenha deixar em branco">
                  <b-form-input
                    id="social-instagram"
                    type="url"
                    v-model="form.social_instagram"
                    placeholder="https://www.instagram.com/user/?hl=pt-br">
                  </b-form-input>
              </b-form-group>
            </div>
            <h3 class="mt-4 mb-4">
              Whatsapp
            </h3>
            <div class="row">
              <b-form-group
                id="group"
                class="col-4"
                label="Whatsapp 1"
                label-for="social-whatsapp-1"
                description="Caso não tenha deixar em branco">
                  <b-form-input
                    id="social-whatsapp-1"
                    class="phone"
                    type="text"
                    v-model="form.social_whatsapp_1"
                    placeholder="+55 (16) 99999-9999"
                    v-mask="['+## (##) ####-####', '+## (##) #####-####']"
                    >
                  </b-form-input>
              </b-form-group>
              <b-form-group
                id="group"
                class="col-4"
                label="Whatsapp 2"
                label-for="social-whatsapp-2"
                description="Caso não tenha deixar em branco">
                  <b-form-input
                    id="social-whatsapp-2"
                    type="text"
                    v-model="form.social_whatsapp_2"
                    placeholder="+55 (16) 99999-9999"
                    v-mask="['+## (##) ####-####', '+## (##) #####-####']"
                    >
                  </b-form-input>
              </b-form-group>
              <b-form-group
                id="group"
                class="col-4"
                label="Whatsapp 3"
                label-for="social-whatsapp-3"
                description="Caso não tenha deixar em branco">
                  <b-form-input
                    id="social-whatsapp-3"
                    type="text"
                    v-model="form.social_whatsapp_3"
                    placeholder="+55 (16) 99999-9999"
                    v-mask="['+## (##) ####-####', '+## (##) #####-####']"
                    >
                  </b-form-input>
              </b-form-group>
            </div>
            <div class="row">
              <b-form-group
                id="group"
                class="col-4"
                label="Whatsapp 4"
                label-for="social-whatsapp-4"
                description="Caso não tenha deixar em branco">
                  <b-form-input
                    id="social-whatsapp-4"
                    type="text"
                    v-model="form.social_whatsapp_4"
                    placeholder="+55 (16) 99999-9999"
                    v-mask="['+## (##) ####-####', '+## (##) #####-####']"
                    >
                  </b-form-input>
              </b-form-group>
              <b-form-group
                id="group"
                class="col-4"
                label="Whatsapp 5"
                label-for="social-whatsapp-5"
                description="Caso não tenha deixar em branco">
                  <b-form-input
                    id="social-whatsapp-5"
                    type="text"
                    v-model="form.social_whatsapp_5"
                    placeholder="+55 (16) 99999-9999"
                    v-mask="['+## (##) ####-####', '+## (##) #####-####']"
                    >
                  </b-form-input>
              </b-form-group>
              <b-form-group
                id="group"
                class="col-4"
                label="Whatsapp 6"
                label-for="social-whatsapp-6"
                description="Caso não tenha deixar em branco">
                  <b-form-input
                    id="social-whatsapp-6"
                    type="text"
                    v-model="form.social_whatsapp_6"
                    placeholder="+55 (16) 99999-9999"
                    v-mask="['+## (##) ####-####', '+## (##) #####-####']"
                    >
                  </b-form-input>
              </b-form-group>
            </div>
            <h3 class="mt-4 mb-4">
              Dados de Contato
            </h3>
            <div class="row">
              <b-form-group
                id="group"
                class="col-6"
                label="E-mail"
                label-for="contact_email">
                  <b-form-input
                    id="contact_email"
                    type="text"
                    v-model="form.contact_email"
                    placeholder="">
                  </b-form-input>
              </b-form-group>
              <b-form-group
                id="group"
                class="col-6"
                label="Telefone"
                label-for="contact_phone_1">
                  <b-form-input
                    id="contact_phone_1"
                    type="text"
                    v-model="form.contact_phone_1"
                    placeholder=""
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    >
                  </b-form-input>
              </b-form-group>
              <!-- <b-form-group
                id="group"
                class="col-4"
                label="Telefone 2"
                label-for="contact_phone_2"
                description="Caso não tenha deixar em branco">
                  <b-form-input
                    id="contact_phone_2"
                    type="text"
                    v-model="form.contact_phone_2"
                    placeholder=""
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    >
                  </b-form-input>
              </b-form-group> -->
            </div>
            <div class="row">

              <b-form-group id="group"
                class="col-12 col-sm-6"
                label="Endereço Completo"
                label-for="contact_complete_address">

                <code-textarea id="contact_complete_address"
                  v-model="form.contact_complete_address"
                  :height="160"
                  :upload="false"
                  :class="{
                    'is-invalid': submitted && form.errors.has('contact_complete_address'),
                    'is-valid': submitted && !form.errors.has('contact_complete_address')
                  }"></code-textarea>
              </b-form-group>

              <b-form-group id="group"
                class="col-12 col-sm-6"
                label="Atendimento"
                label-for="contact_attendance">

                <code-textarea
                  v-model="form.contact_attendance"
                  :height="160"
                  :upload="false"
                  :class="{
                    'is-invalid': submitted && form.errors.has('contact_attendance'),
                    'is-valid': submitted && !form.errors.has('contact_attendance')
                  }"></code-textarea>
              </b-form-group>

            </div>
            <!-- <div class="row">

              <b-form-group id="group"
                class="col-12 col-sm-12"
                label="Google Maps"
                label-for="contact_google_maps">

                <code-textarea id="contact_google_maps"
                  v-model="form.contact_google_maps"
                  :height="50"
                  :upload="false"
                  :class="{
                    'is-invalid': submitted && form.errors.has('contact_google_maps'),
                    'is-valid': submitted && !form.errors.has('contact_google_maps')
                  }"></code-textarea>
              </b-form-group>

            </div> -->
          </div>

          <div id="privacyAndCookies" class="tabcontent">
            <h3 class="mt-4 mb-4">
              Privacidade e Cookies
            </h3>
            <div class="row">
              <div class="col-lg-12">
                <label for="privacy_and_cookies">Modal Informativo de uso dos cookies *</label>
                <editor id="privacy_and_cookies"
                  v-on:getEditor="setEditorData('privacy_and_cookies', arguments[0])"
                  :data="form.privacy_and_cookies"
                  :class="{'is-invalid': form.errors.has('privacy_and_cookies')}">
                </editor>
              </div>
            </div>
            <br/><br/>
            <div class="row">
              <div class="col-lg-12">
                <label for="privacy_policy">Política de Privacidade *</label>
                <editor id="privacy_policy"
                  v-on:getEditor="setEditorData('privacy_policy', arguments[0])"
                  :data="form.privacy_policy"
                  :class="{'is-invalid': form.errors.has('privacy_policy')}">
                </editor>
              </div>
            </div>

          </div>

          <div class="text-right">
            <b-button type="submit" variant="success">
              Atualizar
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import {mask} from 'vue-the-mask'
import { get, set, isObject, clone } from 'lodash'
import { resolveHTTP } from '@/services/api'
import Form from '@/services/form'
import { mapActions } from 'vuex'
import Editor from '../ui/Editor.vue'

export default {
  directives: {mask},
  data () {
    return {
      show: false,
      processing: false,
      submitted: false,
      http: null,
      form: new Form({}, { resetOnSuccess: false }),
      file: {},
      confirmRemoveModal: false,
      confirmRemovePage: false,
      pageToRemove: '',
      empty: {
        _attach_files: [],
        contact_receivers_budget: '',
        contact_receivers_campaign: '',
        seo_pages: {
          url: '',
          title: '',
          description: ''
        },
        social_twitter: '',
        social_youtube: '',
        social_facebook: '',
        social_linkedin: '',
        social_instagram: '',
        social_whatsapp_1: '',
        social_whatsapp_2: '',
        social_whatsapp_3: '',
        social_whatsapp_4: '',
        social_whatsapp_5: '',
        social_whatsapp_6: '',
        contact_email: '',
        contact_phone_1: '',
        contact_phone_2: '',
        contact_complete_address: '',
        privacy_and_cookies: '',
        privacy_policy: '',
        contact_attendance: '',
        contact_google_maps: ''
      }
    }
  },
  components: {
    Editor
  },
  methods: {
    setEditorData (path, value) {
      if (value) {
        set(this.form, path, value)
      } else {
        set(this.form, path, '')
      }
    },
    ...mapActions({
      clearError: 'errors/clearError'
    }),
    setFormData (data) {
      this.form = new Form({
        contact_receivers: data.contact_receivers || '',
        contact_receivers_budget: data.contact_receivers_budget || '',
        contact_receivers_campaign: data.contact_receivers_campaign || '',
        contact_receivers_we_bought_your_used: data.contact_receivers_we_bought_your_used || '',
        seo_pages: data.seo_pages || [],
        social_twitter: data.social_twitter || '',
        social_youtube: data.social_youtube || '',
        social_facebook: data.social_facebook || '',
        social_linkedin: data.social_linkedin || '',
        social_instagram: data.social_instagram || '',
        social_whatsapp_1: data.social_whatsapp_1 || '',
        social_whatsapp_2: data.social_whatsapp_2 || '',
        social_whatsapp_3: data.social_whatsapp_3 || '',
        social_whatsapp_4: data.social_whatsapp_4 || '',
        social_whatsapp_5: data.social_whatsapp_5 || '',
        social_whatsapp_6: data.social_whatsapp_6 || '',
        contact_email: data.contact_email || '',
        contact_phone_1: data.contact_phone_1 || '',
        contact_phone_2: data.contact_phone_2 || '',
        contact_complete_address: data.contact_complete_address || '',
        privacy_and_cookies: data.privacy_and_cookies || '',
        privacy_policy: data.privacy_policy || '',
        contact_attendance: data.contact_attendance || '',
        contact_google_maps: data.contact_google_maps || ''
      }, { resetOnSuccess: false })
    },
    refresh () {
      const self = this
      self.processing = true
      self.$Progress.start()
      self.http.index()
        .then((res) => {
          self.$Progress.finish()
          self.processing = false
          self.setFormData(res.data)
          self.show = false
          self.$nextTick(() => { this.show = true })
        }).catch(() => {
          self.$Progress.fail()
          self.processing = false
          self.$toasted.info('Houve um erro receber as configurações')
        })
    },
    onSubmit (evt) {
      const self = this
      self.clearError(['UnprocessableEntity'])
      self.processing = true
      self.submitted = false
      self.form.put(self.http.getRoute('store'))
        .then(([data, res]) => {
          self.submitted = true
          self.processing = false
          self.$toasted.success('Configurações atualizadas com sucesso')
        }).catch((e) => {
          self.submitted = true
          self.processing = false
        })
    },
    onReset (evt) {
      this.form.reset()
      this.submitted = false
      this.show = false
      this.$nextTick(() => { this.show = true })
    },
    updateForm (path, value, valuePath) {
      set(this.form, path, isObject(value) ? get(value || {}, valuePath || 'id', null) : value)
    },
    open (evt, name) {
      let i, tabcontent, tablinks
      tabcontent = document.getElementsByClassName('tabcontent')
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = 'none'
      }
      tablinks = document.getElementsByClassName('tablinks')
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace('active', '')
      }
      document.getElementById(name).style.display = 'block'
      evt.currentTarget.className += ' active'
    },
    newSEOPage () {
      this.form.seo_pages.unshift(clone(this.empty.seo_pages))
      setTimeout(() => {
        const $firstInput = document.getElementById(`seo-url-0`)
        $firstInput.focus()
      }, 500)
    },
    openRemovePageModal (index) {
      this.confirmRemovePage = true
      this.pageToRemove = index
    },
    removeSEOPage () {
      this.form.seo_pages.splice(this.pageToRemove, 1)
      this.$toasted.success('Página removida com sucesso')
    }
  },
  created () {
    this.http = resolveHTTP('/settings')
    this.form.withData(clone(this.empty)).setInitialValues(clone(this.empty))
  },
  mounted () {
    this.refresh()

    document.getElementById('defaultOpen').click()
    const tab = this.$route.query.tab
    if (tab) {
      const $el = document.getElementsByClassName(`tab-${tab}`)[0]
      $el.click()
    }
  }
}
</script>

<style media="screen" scoped lang="scss">
  .card-header {
    margin-bottom: -1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Settings.vue